module.exports = __webpack_public_path__ + "static/media/PM4.821fd37f.JPG";